import { CaseStatus } from '@/api/apis/case';

export const organOnOcsStatuses = [
  CaseStatus.OrganOnOCS,
  CaseStatus.DeployedToTXCenter,
  CaseStatus.AtTXCenter,
  CaseStatus.OrganOffOCS,
];

export const declineStatuses = [CaseStatus.Declined, CaseStatus.ServiceDeclined];

export const logisticsStatuses = [
  CaseStatus.Accepted,
  CaseStatus.PendingLogistics,
  CaseStatus.ResourcesBooked,
  CaseStatus.ResourceDeployed,
  CaseStatus.AtDonorHospital,
  CaseStatus.OrganOnOCS,
  CaseStatus.DeployedToTXCenter,
  CaseStatus.AtTXCenter,
  CaseStatus.OrganOffOCS,
  CaseStatus.ServiceDeclined,
  CaseStatus.ReturningToBase,
  CaseStatus.Finished,
];

export const serviceOutcomeStatuses = [
  CaseStatus.AtDonorHospital,
  CaseStatus.OrganOnOCS,
  CaseStatus.DeployedToTXCenter,
  CaseStatus.AtTXCenter,
  CaseStatus.OrganOffOCS,
];

export const afterOcsStatuses = [
  CaseStatus.ServiceDeclined,
  CaseStatus.ReturningToBase,
  CaseStatus.Finished,
  CaseStatus.Closed,
];

export const scsStatuses = [
  CaseStatus.OrganOnOCS,
  CaseStatus.DeployedToTXCenter,
  CaseStatus.AtTXCenter,
  CaseStatus.OrganOffOCS,
];

export const atTxCenterStatuses = [...organOnOcsStatuses, ...afterOcsStatuses];
